
Array.prototype.isempty = function () {
  return (this == null || this.length == 0);
};

